import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Action } from "typescript-fsa";

import type { DownloadButtonProps } from "./presenter";
import { DownloadButton as Presenter } from "./presenter";
import { ApiState } from "../../models/state";
import { ApiRequest } from "../../requests";
import { Api } from "../../index";
import { getAllRequests } from "../../selectors";

// Map the auth state to the component.
function mapStateToProps(state: ApiState) {
    return {
        requests: getAllRequests(state),
    } as DownloadButtonProps;
}

// Map the request login action to the component
function mapDispatchToProps(dispatch: Dispatch<ApiState>, props: DownloadButtonProps) {
    let actionCreator: () => Action<ApiRequest> = () => Api.downloadFile(props.url);
    if (props.actionCreator) {
        actionCreator = props.actionCreator;
    }
    return {
        download: () => {
            const action = actionCreator();
            dispatch(action);
            return action;
        },
    } as DownloadButtonProps;
}

// Connect the component to Redux.
const DownloadButton = connect<{}, {}, DownloadButtonProps>
    (mapStateToProps, mapDispatchToProps)(Presenter);

export { DownloadButton, DownloadButtonProps };
